// extracted by mini-css-extract-plugin
export var content = "FeaturePanel-module--content--Vz6EX";
export var content_container = "FeaturePanel-module--content_container--i3ajL";
export var copy_container = "FeaturePanel-module--copy_container--q5oGB";
export var cta_container = "FeaturePanel-module--cta_container--zMl0+";
export var title = "FeaturePanel-module--title---Zi6h";
export var title_container = "FeaturePanel-module--title_container--y7nHc";